import { render, staticRenderFns } from "./JobFamilyCard.vue?vue&type=template&id=4a7d2f54&scoped=true"
import script from "./JobFamilyCard.vue?vue&type=script&setup=true&lang=js"
export * from "./JobFamilyCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./JobFamilyCard.vue?vue&type=style&index=0&id=4a7d2f54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7d2f54",
  null
  
)

export default component.exports